module.exports = __webpack_public_path__ + "static/business-consulting-4894c6cef219e6aaa9b8f5af0ebce26b.jpg";